import { Text, Group, Skeleton } from '@mantine/core';
import { IconSnowflake, IconWallet } from '@tabler/icons-react';
import { type FC } from 'react';
import { Currency, getCurrencyIcon } from '~/entities/currency';
import { useBreakpoint } from '~/shared/lib/hooks/useBreakpoint';
import styles from './Balances.module.css';

interface BalancesProps {
    available?: string;
    hold?: string;
    currency?: Currency;
    isLoading?: boolean;
}

export const Balances: FC<BalancesProps> = ({
    available,
    hold,
    currency = Currency.CURRENCY_RUB,
    isLoading = true,
}) => {
    const isMobile = useBreakpoint('mobile');
    const isTablet = useBreakpoint('tablet');

    const isVisible = isLoading || !available || !hold;

    return (
        <Skeleton
            visible={isVisible}
            w={!isMobile ? 'auto' : '100%'}
        >
            <Group
                gap={8}
                justify={!isMobile ? 'space-between' : 'center'}
            >
                <Group
                    gap={4}
                    wrap='nowrap'
                >
                    <IconWallet
                        size={16}
                        className={styles.icon}
                    />

                    {!isTablet && (
                        <Text
                            fz={12}
                            fw={600}
                            className={styles.label}
                        >
                            Доступно
                        </Text>
                    )}

                    <Text
                        fz={14}
                        fw={700}
                        className={styles.value}
                    >
                        <Group
                            component='span'
                            align='center'
                            gap={0}
                        >
                            {available}

                            {getCurrencyIcon(currency)}
                        </Group>
                    </Text>
                </Group>

                <Group
                    gap={4}
                    wrap='nowrap'
                    className={styles.item}
                >
                    <IconSnowflake
                        size={14}
                        className={styles.holdIcon}
                    />

                    {!isTablet && (
                        <Text
                            fz={12}
                            fw={600}
                            className={styles.label}
                        >
                            Заморожено
                        </Text>
                    )}

                    <Text
                        fz={14}
                        fw={700}
                        className={styles.holdValue}
                    >
                        <Group
                            component='span'
                            align='center'
                            gap={0}
                        >
                            {hold}

                            {getCurrencyIcon(currency)}
                        </Group>
                    </Text>
                </Group>
            </Group>
        </Skeleton>
    );
};
